module.exports = __webpack_public_path__ + "img/36fe2b8452f7efae57323cc03609394d.png";